import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import Upload from '@/views/components/upload/upload.vue';
import { Functions } from '@/library/utils/functions';
import { noop } from '@/util';
import importBatchSet from '@/views/components/importBatchSet';
import CornerView from '@/views/components/cornerView';

interface formItem {
  tagPlace: string;
  tagPic: string;
  tagName: string;
  beginTime: Array<any>;
  endTime: Array<any>;
  checked: boolean;
  productCodes: GoodsInfo[];
  date: any[];
}
export const selectList = [
  { label: '左上角', value: '1' },
  { label: '右上角', value: '2' },
  { label: '底部', value: '5' },
];
@Component({
  mixins: [style],
  components: {
    Upload,
    CornerView,
  },
})
export default class createCorner extends Vue {
  /**
   * 添加活动列表
   * @type {formObj}
   */
  public cornerForm: Partial<formItem> = {
    tagPlace: '1',
    tagPic: '',
    tagName: '',
    date: [],
    productCodes: [],
    checked: false,
  };

  /**
   * 图片上传地址
   * @type {string}
   */
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  // siteId
  public siteId: number = null;

  // type edit为编辑 create为创建
  @Prop({ default: '' })
  public pageType: string;

  // tagId 角标id
  @Prop({ default: null })
  public tagId: number;

  @Watch('tagId', { immediate: true })
  onTagIdChange(n, o) {
    if (n && n !== o) {
      this.siteId = Number(this.$route.params.siteId);
      this.getData();
    }
  }

  // 选择商品弹窗返回数组
  public = [];

  $refs: {
    cornerFormRef: ElForm;
  };

  rules = {
    tagName: [{ required: true, message: '请输入名称', trigger: ['change', 'blur'] }],
    productCodes: [{ trigger: ['change', 'blur'], validator: this.validatorList }],
    date: [{ trigger: ['change', 'blur'], validator: this.validatorDate }],
  };

  public validatorDate(rule, value, callback) {
    if (this.cornerForm.checked) {
      return callback();
    } else {
      if (!this.cornerForm.date || !this.cornerForm.date[0] || !this.cornerForm.date[1]) {
        return callback(new Error('请选择展示有效期'));
      }
    }
    return callback();
  }

  public validatorList(rule, value, callback) {
    if (this.cornerForm.productCodes && this.cornerForm.productCodes.length) {
      return callback();
    } else {
      return callback(new Error('请选择商品'));
    }
    return callback();
  }

  /**
   * 图片上传失败
   * @return null
   */
  public uploadImgError(): void {
    this.$message.error('图片上传失败');
  }

  /**
   * 上传图片成功回调
   * @param {val}
   */
  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.cornerForm.tagPic = res.content;
  }

  // 展示位置选择
  public onSelect(val) {
    // this.cornerForm.tagPic = "";
  }

  // 导入货号
  importGoodsNum() {
    importBatchSet
      .open({
        title: '导入货号',
        fromKey: 'importgoodsnum',
        postParams: {},
        data: [],
        excelHeader: [{ header: '货号', key: '1', width: 10 }],
        name: '导入货号空白模板',
      })
      .then((result) => {
        this.cornerForm.productCodes = result.result || [];
      }, noop);
  }

  // 编辑时获取数据
  getData() {
    const params = {
      siteId: this.siteId,
      tagId: this.tagId,
    };
    IPSService.tagMappingInfo({
      postParams: params,
    }).then((res) => {
      this.cornerForm.productCodes = res.productCodes;
      this.cornerForm.tagName = res.tagName;
      this.cornerForm.tagPic = res.tagPic;
      this.cornerForm.tagPlace = String(res.tagPlace);
      if (res.beginTime === 0) {
        this.cornerForm.date = [];
      } else {
        this.cornerForm.date[0] = res.beginTime * 1000;
        this.cornerForm.date[1] = res.endTime * 1000;
      }

      this.cornerForm.checked = res.beginTime == 0;
    });
  }

  // 确认添加
  onSure() {
    if (this.cornerForm.productCodes.length == 0) {
      this.$message.error('请添加商品货号');
      return;
    }
    if (!this.cornerForm.tagPic) {
      this.$message.error('请上传图片');
      return;
    }

    this.$refs.cornerFormRef.validate().then(
      (valid) => {
        if (valid) {
          this.$confirm('确认保存？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            const params = {
              tagId: this.tagId,
              siteId: Number(this.$route.params.siteId),
              tagName: this.cornerForm.tagName,
              productCodes: this.cornerForm.productCodes,
              tagPlace: Number(this.cornerForm.tagPlace),
              tagPic: this.cornerForm.tagPic,
              beginTime: this.cornerForm.checked ? 0 : Number(this.cornerForm.date[0]) / 1000,
              endTime: this.cornerForm.checked ? 2114352000 : Number(this.cornerForm.date[1]) / 1000,
            };
            IPSService.tagMappingSave({
              postParams: params,
            }).then((response) => {
              if (response.result) {
                this.$message({
                  message: '添加成功！',
                  type: 'success',
                });
                this.$emit('detail', true);
              }
            });
          });
        }
      },
      (rej) => {
        console.log(rej);
      },
    );
  }

  // 取消
  onCancel() {
    this.$confirm('确认取消？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      this.$emit('detail', false);
    });
  }

  // 子组件 传来的 删除事件
  deleteImg() {
    this.cornerForm.tagPic = '';
  }

  render(h) {
    return (
      <div class="cornerPage">
        {/* 面包屑导航 */}
        <div class="breadCrumbBar">
          <span class="font-size-16 font-bold">{this.tagId ? '编辑' : '新建'}角标</span>
        </div>
        {/* 内容 */}
        <div class="content">
          {/* 展示页 */}
          <div class="left">
            <p class="title r-pl-30 line-height-40">商品列表示意图</p>
            <CornerView selected={this.cornerForm.tagPlace} on-deleteImg={this.deleteImg.bind(this)} imgUrl={this.cornerForm.tagPic} />
          </div>
          {/* 表单部分 */}
          <div class="right flex column no-scroll">
            <div class="flex1 scroll-y full-width">
              <el-form class="formContent" label-width="140px" ref="cornerFormRef" props={{ model: this.cornerForm }} label-position="left" rules={this.rules}>
                <div class="formItemWrapper">
                  <el-form-item label="选择商品" prop="productCodes" required>
                    <el-button type="primary" size="medium" onClick={this.importGoodsNum}>
                      导入货号
                    </el-button>
                  </el-form-item>
                </div>
                {this.cornerForm.productCodes.length > 0 ? (
                  <div class="formItemWrapper">
                    <el-form-item label="已添加商品" prop="list">
                      <div class="selectedgoods">
                        {this.cornerForm.productCodes.map((item, index) => {
                          return (
                            <span class="span">
                              {item}
                              {index === this.cornerForm.productCodes.length - 1 ? '' : ','}
                            </span>
                          );
                        })}
                      </div>
                    </el-form-item>
                  </div>
                ) : (
                  ''
                )}
                <div class="formItemWrapper">
                  <el-form-item label="名称" prop="tagName" required>
                    <el-input class="wid-190" v-model={this.cornerForm.tagName} placeholder="请输入名称" maxlength="20" show-word-limit />
                  </el-form-item>
                </div>
                <div class="formItemWrapper">
                  <el-form-item label="展示位置" prop="tagPlace" required>
                    <el-select v-model={this.cornerForm.tagPlace} placeholder="请选择" class="wid-60" onChange={val => this.onSelect(val)}>
                      {selectList.map((v, i) => {
                        return <el-option label={v.label} value={v.value} />;
                      })}
                    </el-select>
                    <Upload fileList={false} onImgUploadSuccess={val => this.uploadSuccess(val)} img={this.cornerForm.tagPic} noDelete={false} maxSize={1024} />
                    {this.cornerForm.tagPlace != '5' ? (
                      <div>
                        <p class="tip">注1： 建议图片分辨率为375*375px；</p>
                        <p class="tip">注2： 每张图片大小不超过1M，支持png、gif透底图像格式；</p>
                        <p class="tip">注3： 左上角及右上角的图标仅会出现在商品列表。</p>
                      </div>
                    ) : (
                      <div>
                        <p class="tip">注1： 建议图片分辨率为750*375px；</p>
                        <p class="tip">注2： 每张图片大小不超过1M，支持png、gif透底图像格式；</p>
                        <p class="tip">注3： 商品详情中仅显示底部角标。</p>
                      </div>
                    )}
                  </el-form-item>
                </div>
                <div class="formItemWrapper">
                  <el-form-item label="" prop="date">
                    <span slot="label">
                      展示有效期<i class="red">&nbsp;*</i>
                    </span>
                    <el-date-picker
                      v-model={this.cornerForm.date}
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="timestamp"
                      picker-options={{
                        disabledDate(time) {
                          return time.getTime() > 2082729600000;
                        },
                      }}
                      disabled={this.cornerForm.checked}
                    />
                  </el-form-item>
                  <div class="checkbox">
                    <el-checkbox v-model={this.cornerForm.checked}>长期有效</el-checkbox>
                  </div>
                </div>
              </el-form>
            </div>
            <div class="button flex-s-0 index-9">
              <el-button type="primary" onClick={this.onSure.bind(this)}>
                确认添加
              </el-button>
              <el-button onClick={this.onCancel.bind(this)}>取消</el-button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
